/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('store.pending-order-notice', function (el) {
        var notice = new PendingOrderNotice(el);
        notice.run();
    });
    var PendingOrderNotice = /** @class */ (function () {
        function PendingOrderNotice(el) {
            this.el = el;
            this.stock = el.dataset.stock;
            this.template = el.dataset.template;
            this.templatePluralPostfix = el.dataset.templatePluralPostfix;
            this.form = el.closest('form');
            this.qtySelect = this.form.querySelector('#qty');
        }
        PendingOrderNotice.prototype.run = function () {
            this.delegateFormChange();
        };
        PendingOrderNotice.prototype.delegateFormChange = function () {
            var _this = this;
            this.updateNotice();
            util.delegate(document.body, 'change', '.storeProductForm', function () {
                _this.updateProperties();
                _this.updateNotice();
            });
        };
        PendingOrderNotice.prototype.getSelectedQty = function () {
            return parseInt(this.qtySelect.value);
        };
        PendingOrderNotice.prototype.getPendingCount = function () {
            return Math.max(0, (this.getSelectedQty() - this.stock));
        };
        PendingOrderNotice.prototype.updateProperties = function () {
            var variantSelection = MoyaContainer.get('store.variant-selection');
            this.form = this.el.closest('form');
            this.qtySelect = this.form.querySelector('#qty');
            if (variantSelection) {
                this.stock = variantSelection.getSelectedVariant().stock;
            }
        };
        PendingOrderNotice.prototype.updateNotice = function () {
            this.updateNoticeText();
            this.toggle();
        };
        PendingOrderNotice.prototype.updateNoticeText = function () {
            var contentElement = this.el.querySelector('.content');
            if (this.getPendingCount() <= 0) {
                contentElement.textContent = '';
            }
            else {
                var text = this.template;
                text = text.replace('{qty}', this.getSelectedQty().toString());
                text = text.replace('{pluralPostfix}', this.getPendingCount() > 1 ? this.templatePluralPostfix : '');
                text = text.replace('{pendingCount}', this.getPendingCount().toString());
                contentElement.innerText = text;
            }
        };
        PendingOrderNotice.prototype.toggle = function () {
            if (this.getPendingCount() > 0) {
                this.show();
            }
            else {
                this.hide();
            }
        };
        PendingOrderNotice.prototype.show = function () {
            this.el.dataset.hidden = 'false';
        };
        PendingOrderNotice.prototype.hide = function () {
            this.el.dataset.hidden = 'true';
        };
        return PendingOrderNotice;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
